import { EventBus } from 'vtils'

export enum AfterSalesType {
  退款 = 1,
  退货退款 = 2,
  换货 = 3,
}

export const afterSalesBus = new EventBus<{
  updateDetailId: (id: string) => any
}>()
